import React from 'react'
import { Button, TextInput } from 'is24-corecss'

import { API_ENDPOINT, BUILD_DATE } from '../../../config'
import { FLOW_CHOOSER_PATH } from '../../../services/routes/routes'

const LoginPage: React.FC = () => {
  return (
    <div className='padding-xl'>
      <h3>Local Login Mock</h3>
      <h2>Anmelden oder registrieren</h2>

      <div className='grid grid-flex gutter-m'>
        <div className='grid-item one-whole'>
          <TextInput.Root className='UserName' id='user-name'>
            <TextInput.Label>User Name</TextInput.Label>
            <TextInput.Input value={'user'} placeholder={'user name'} readOnly />
          </TextInput.Root>
        </div>

        <div className='grid-item one-whole'>
          <TextInput.Root className='Password' id='password'>
            <TextInput.Label>Password</TextInput.Label>
            <TextInput.Input value={'password'} placeholder={'password'} type='password' readOnly />
          </TextInput.Root>
        </div>

        <div className='grid-item one-whole'>
          <Button
            className='LoginButton'
            id='submit'
            onClick={() => {
              const searchParams = new URLSearchParams(window.location.search)
              if (searchParams.get('sso_return')) {
                window.location.href = `${API_ENDPOINT}/insertion-flow/sso-login?${searchParams}`
              } else {
                window.location.href = `${API_ENDPOINT}/insertion-flow/sso-login?sso_return=${FLOW_CHOOSER_PATH}`
              }
            }}
          >
            Login
          </Button>
        </div>
        <div className='grid-item one-whole'>
          <span>{`Build Date: ${BUILD_DATE}`}</span>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
